import { render, staticRenderFns } from "./elementSeoText.vue?vue&type=template&id=12614ac6&scoped=true"
import script from "./elementSeoText.vue?vue&type=script&lang=ts"
export * from "./elementSeoText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12614ac6",
  null
  
)

export default component.exports